/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linkcopied1Inputs */

const en_linkcopied1 = /** @type {(inputs: Linkcopied1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied`)
};

const de_linkcopied1 = /** @type {(inputs: Linkcopied1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopiert`)
};

/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Linkcopied1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const linkcopied1 = /** @type {((inputs?: Linkcopied1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linkcopied1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_linkcopied1(inputs)
	return de_linkcopied1(inputs)
});
export { linkcopied1 as "linkCopied" }